import Axios from '../baseApi';

export default {
  addOrUpdate(form) {
    return Axios.post(`/api-article/freighters/v1`, form);
  },
  changeSelf(form) {
    return Axios.post(`/api-article/freighters/v1/change-self`, form);
  },
  fetch(id, fetchFromTransport) {
    return Axios.get(`/api-article/freighters/v1?${id}&fetchFromTransport=${fetchFromTransport}`);
  }
}
